<template>
    <div class="content-date-hour" id="content-date-hour">
        <div class="row ">
            <div class="col-xs-7 no-margin-bottom" v-bind:class="{timeStartAccepted:accepted}" v-if="editTime===false">
                    <nl2br tag="span" :text="label"/>
            </div>

            <div class="col-xs-5 hour-block no-margin-bottom">
                <span class="heure_start " @click="editTime=true">
                        {{workTimeStartFormated}}
                </span>
                <input type="checkbox" class="pull-right" @click="$emit('toggleAcceptation')" v-bind:checked="accepted" id="validate_checkbox" v-if="editTime===false">
            </div>

            <div class="col-xs-7  btns-inc" v-if="editTime===true">
                <button class="btn btn-primary btn-sm btn-inc-hour pull-left" @click="changeTime('inc')"><i
                        class="fa fa-arrow-up"></i></button>
                <button class="btn btn-primary btn-sm btn-inc-hour pull-left" @click="changeTime('dec')"><i
                        class="fa fa-arrow-down"></i></button>
                <button class="btn btn-primary btn-sm btn-inc-hour pull-left" @click="editTime=false">OK</button>
            </div>
        </div>
    </div>
</template>

<script>

    import moment from 'moment-timezone';

    export default {
        props: {
            value:null,
            accepted:Boolean,
            label:String,
            confirmHourVisible:Boolean
        },
        data() {
            return {
                incrementTimeMinutesInterval: 10,
                editTime: false,
            }
        },
        created (){

        },
        methods: {
            changeTime(inc_dec) {
                if (inc_dec === "dec") {
                    this.$emit('input', moment(this.value).subtract(this.incrementTimeMinutesInterval, 'm').toDate())
                } else {
                    if(!moment(this.value).isSameOrAfter(moment())){
                        this.$emit('input', moment(this.value).add(this.incrementTimeMinutesInterval, 'm').toDate())
                    }
                }

            }
        },
        computed: {
            workTimeStartFormated() {
                return moment(this.value).format('HH:mm');
            }
        }
    }
</script>

<style lang="scss" scoped>

    .accept-btn {
        margin: 5px 0px;
        background-color: #e1e1dd;
        min-height: 36px !important;
        width: 37px !important;
    }


    .no-padding-right {
        padding-right: 5px !important;
    }

    .btns-inc {
        padding-left: 0px !important;
    }

    .align-to-title{
        margin-top:14px;
    }

    .content-date-hour{
        background-color:white;
        margin-bottom:4px;
        padding:10px;
    }

    #validate_checkbox{
        /* Double-sized Checkboxes */
        -ms-transform: scale(2); /* IE */
        -moz-transform: scale(2); /* FF */
        -webkit-transform: scale(2); /* Safari and Chrome */
        -o-transform: scale(2); /* Opera */
        margin:12px 8px;
    }

    .heure_start {
        font-size:24px;
        color:gray;
        font-weight: bold;
    }
    .timeStartAccepted{
        margin-bottom: 0px !important;
    }
    .hour-block{
        padding-left:0px !important;
    }

    #content-date-hour .no-margin-bottom {
        margin-bottom: 0px !important;
    }

</style>